import {useEffect} from 'react';

const SITE = 'ЭБС ГГНТУ «Digital Book»';

const clean = (text) => (text || '').replace(/\s+/g, ' ').trim();

/** Заголовок вкладки из того, что уже есть на странице. */
const computeTitle = () => {
    if (window.location.pathname.startsWith('/admin')) {
        const h1 = clean(document.querySelector('.adm-page-title')?.textContent);
        return h1 ? `${h1} — Админка ЭБС ГГНТУ` : 'Админка ЭБС ГГНТУ';
    }

    // Публичная часть: последняя «хлебная крошка» — название текущей страницы.
    const items = [...document.querySelectorAll('.breadcrumdCont .breadcrumbItem')]
        .map((el) => clean(el.textContent))
        .filter(Boolean);
    const last = items[items.length - 1];
    if (!last) return SITE;

    // Крошки в верхнем регистре (названия изданий) читаются в заголовке тяжело.
    const pretty = last === last.toUpperCase() ? last.charAt(0) + last.slice(1).toLowerCase() : last;
    const capitalized = pretty.charAt(0).toUpperCase() + pretty.slice(1);
    return `${capitalized.replace(/\.\.\.$/, '…')} — ЭБС ГГНТУ`;
};

/**
 * Держит document.title в соответствии с открытой страницей. Раньше у всех
 * страниц был одинаковый заголовок, и вкладки/историю браузера было не различить.
 * Страницы ничего не делают сами: заголовок берётся из «хлебных крошек»
 * (в админке — из заголовка страницы) и обновляется, когда они меняются.
 */
export const useAutoTitle = () => {
    useEffect(() => {
        let frame = null;
        const update = () => {
            if (frame) return;
            frame = requestAnimationFrame(() => {
                frame = null;
                const title = computeTitle();
                if (document.title !== title) document.title = title;
            });
        };

        update();
        const observer = new MutationObserver(update);
        observer.observe(document.getElementById('root') || document.body, {
            childList: true,
            subtree: true,
            characterData: true,
        });
        return () => {
            observer.disconnect();
            if (frame) cancelAnimationFrame(frame);
        };
    }, []);
};

export default useAutoTitle;
